import {useAppStore} from '../appStore'

export const homeSelectors = {
  useBreadcrumbs: () => useAppStore(s => s.breadcrumbs),
} as const
